import React from "react";
import {Card, Rating} from "flowbite-react";
import Code from "../Code";

const Hero = () => {
    const formyTemplate = process.env.REACT_APP_FORMY_LINK_TEMPLATE;

    const formyForm = `<form action="${formyTemplate}" method="post">
    <input type="email" name="email">
    <textarea name="message"></textarea>
    <input type="submit" value="Send">
</form>`;

    return (
        <section className="bg-white dark:bg-gray-900">
            <div className="py-8 px-4 mx-auto max-w-screen-xl text-center">
                <h1 className="mb-4 text-4xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl dark:text-white">
                    Formy
                </h1>
                <p className="mb-4 text-lg font-normal lg:text-xl sm:px-16 xl:px-48 dark:text-white">
                    Effortless & Serverless Form Handler
                </p>
                <div className="flex justify-center mb-5 text-lg font-normal lg:text-xl sm:px-16 xl:px-48 dark:text-white text-center">
                    <Rating>
                        {[...Array(5)].map((_, i) => <Rating.Star key={i} />)}
                    </Rating>
                </div>
                <div className="flex flex-col mb-8 space-y-4 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-4">
                    <Card className="heroCode">
                        <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                            <p className="pt-4 pb-1">
                                Formy handle your forms as easy as ABC
                            </p>
                        </h5>
                        <div className="font-normal dark:text-gray-200">
                            <Code code={formyForm} language="html" />
                        </div>
                    </Card>
                </div>
                <div className="flex justify-center mt-8 mb-1">
                    <svg width="40px" height="100%" viewBox="0 0 247 390" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                         style={{
                             fillRule: "evenodd",
                             clipRule: "evenodd",
                             strokeLinecap: "round",
                             strokeLinejoin: "round",
                             strokeMiterlimit: 1.5
                         }}>
                        <path id="wheel" d="M123.359,79.775l0,72.843"
                              style={{ fill: "none", stroke: "#fff", strokeWidth: "20px" }} />
                        <path id="mouse"
                              d="M236.717,123.359c0,-62.565 -50.794,-113.359 -113.358,-113.359c-62.565,0 -113.359,50.794 -113.359,113.359l0,143.237c0,62.565 50.794,113.359 113.359,113.359c62.564,0 113.358,-50.794 113.358,-113.359l0,-143.237Z"
                              style={{ fill: "none", stroke: "#fff", strokeWidth: "20px" }} />
                    </svg>
                </div>
            </div>
            <div className="shadow p-3 sm:p-4 xl:p-5 dark:bg-gray-800 text-center">
                <p className="text-white text-1xl md:text-2xl lg:text-3xl font-bold">
                    🎉 <a href="https://github.com/abmohajeri/formy" target="_blank" rel="noopener noreferrer" className="underline"> Clone</a> it and start with our <a href="#prebuilt-forms" className="underline"> Pre-built forms </a>
                </p>
            </div>
        </section>
    );
};

export default Hero;